import { useMediaQuery } from 'react-responsive';

/** The mobile web layout: 768 px and down (navigation design §3, `SMLSectionTabs` `$mobile-max`). */
const MOBILE_QUERY = '(max-width: 768px)';

/**
 * True when the page tabs sit at the top of the page head (design navigation-v2 g 7c): on a phone
 * the title is in the top bar, so the tabs come first and the subtitle goes. On a wider screen the
 * tabs stay in the page body, under the head.
 */
export function usePageTabsOnTop(): boolean {
  return useMediaQuery({ query: MOBILE_QUERY });
}
